import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';

@Component({
  selector: 'app-team',
  imports: [CommonModule],
  templateUrl: './team.component.html',
  styleUrls: ['./team.component.css'],
  standalone: true
})
export class TeamComponent {
  teamMembers = [
    {
      image: 'assets/img/team/am.jpg',
      name: 'Ing. Andres Mirra',
      description: 'Asesor Financiero Independiente (Agente Productor CNV 1995), Ing. Industrial (UTN) y Operador de Mercado de Capitales (IAMC) con amplia experiencia en el mercado de capitales.',
      position1: 'Co-Fundador',
      position2: 'Financial Advisor'
    },
    {
      image: 'assets/img/team/ad.jpg',
      name: 'Lic. Anyelen Dilaj',
      description: 'Asesor Financiero Independiente (Agente Productor CNV 2537), Operadora de Mercado de Capitales  (IAMC) con amplia experiencia y formación en finanzas, idónea en mercado de capitales (CNV)',
      position1: 'Co-Fundadora',
      position2: 'Financial Advisor'
    },
  ];
}